module.exports = new __parcel__URL__("JiraIcon.61c2353c.svg").toString();